import { useOutletContext } from "react-router-dom";
import { useSelector } from "react-redux";

import TwoDViewer from "./TwoDViewer";
import Table from "../../../components/table";
import ServiceInfo from "../../../components/ServiceInfo";
import useStepper from "../../../components/stepper/hooks/useStepper";
import useMediaQuery from "../../../hooks/useMediaQuery";
import { formatToCurrency } from "../../../utils/numbers";
import { CURRENCY } from "../../../constants/common";
import { DesignState } from "../../../features/designSlice";
import { DesignOutletContext } from "..";

function Viewer() {
  const { item } = useOutletContext<DesignOutletContext>() || {};

  const { isFinalStep, currentStep } = useStepper();

  const isMinWidth1024 = useMediaQuery("(min-width: 1024px)");

  const { prices, pricePerStep, priceRangePercentagePerStep, priceMode } =
    useSelector((state: { design: DesignState }) => state.design);

  return (
    <>
      <TwoDViewer />
      {isMinWidth1024 && (
        <>
          {!isFinalStep && (
            <>
              <Table rows={prices.slice(0, currentStep)} />
              <div className="flex items-center justify-between px-5 text-primary">
                <span className="text-[18px] font-medium">Total Price</span>
                <span className="text-[32px] font-bold">
                  {formatToCurrency(
                    pricePerStep[currentStep - 1],
                    CURRENCY,
                    priceRangePercentagePerStep[currentStep - 1],
                    priceMode
                  )}
                </span>
              </div>
            </>
          )}
          <ServiceInfo itemId={item?.id} />
        </>
      )}
    </>
  );
}

export default Viewer;
